import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from 'modules';
import {
  // canPlayAction,
  timeUpdateAction,
  playingAction,
  pauseAction,
  seekedAction,
  endedAction,
  changeVideoDomAction,
  preloadAction,
  setPlayingTimeAction,
  manifestParsedAction,
  seekingAction,
} from 'modules/video';
// import { setFileAction } from "modules/file";
import {
  getFileIndexByTime,
  getTotalDurationByIndex,
  getPausedState,
  getNextFileItem,
  getChangeFileItem,
  getElementVideoTag,
  setElementVideoTag,
  getPlayingTimeByFiles,
  isTimeInCurrentItem,
  // getNextCutFileItem,
  // getCutFileInfo,
  // getPacketizer,
  // getCutNearFiles,
  // getCutListInfo,
} from 'lib/playUtils';
import {IVodInfoData} from 'lib/api/vodInfo';
import {
  AUTH_NO_LIST,
  NEXT_FILE_PREPARE_SECONDS,
  VOD_AFREECATV_DOMAIN,
} from 'constants/config';
import usePlayPause from 'hooks/usePlayPause';
import HlsContainer from 'containers/player/HlsContainer';
import ScreenContainer from 'containers/player/ScreenContainer';
import Video from 'components/player/Video';
import {changePlayingIdxAction, changeSeekChatAction} from 'modules/file';
import useSubscriptionSession from 'hooks/useSubscriptionSession';
// import { changePlayingIdxCutAction } from "modules/cut";
import {t} from 'lib/i18n';

/**
 * Video 컨테이너
 */
const VideoContainer: React.FC = () => {
  const dispatch = useDispatch();
  // const  = useSelector(({video}) => ({}))

  const {
    vodData,
    file,
    video,
    cut,
    timeline: {sectionIdx, sectionLists},
  } = useSelector((state: RootState) => ({
    vodData: state.vodInfo.titleFileInfo.data,
    file: state.file,
    video: state.video,
    cut: state.cut,
    timeline: state.timeline,
  }));
  // const videoRef = useRef<HTMLVideoElement>(null);

  const [_, setPaused] = usePlayPause(video.videoDOM as HTMLVideoElement);

  const {response} = vodData as IVodInfoData;
  const isSubscriptionVod =
    response.info.auth_no === AUTH_NO_LIST.OPEN_SUBSCRIPTION;
  const vodUrl = file.list[file.playingIdx].vod_url;
  const fileOrder = file.list[file.playingIdx].file_order;
  const streamerId = response.info.user_id;
  const titleNo = response.info.title_no;
  // 다음 파일 미리 로드 중이면 구독 세션 체크도 다음 파일 기준으로 호출
  const preloadFileItem = getNextFileItem(file.playingIdx, file.list);
  const subscriptionSession = useSubscriptionSession({
    isSubscriptionVod,
    vodUrl: video.nextPreload ? preloadFileItem.url : vodUrl,
    streamerId,
    titleNo,
    fileOrder: video.nextPreload ? preloadFileItem.fileOrder : fileOrder,
  });

  // 미디어 canplay 이벤트
  // const handleCanPlay = (
  //     e: React.SyntheticEvent<HTMLVideoElement, Event>,
  // ) => {
  //     if (videoRef.current && response.info) {
  //         dispatch(
  //             canPlayAction(videoRef.current, response.info.total_duration),
  //         );
  //     }
  // };

  // 미디어 playing 이벤트
  const handlePlaying = () => {
    dispatch(playingAction());
  };
  // 미디어 paused 이벤트
  const handlePause = () => {
    dispatch(pauseAction());
  };
  // 미디어 timeupdate 이벤트
  const handleTimeUpdate = () => {
    if (!response.files) {
      // console.error("handleTimeUpdate > response.files ERROR!!");
      return;
    }
    if (!file) {
      // console.error("handleTimeUpdate > file ERROR!!");
      return;
    }
    if (!video.videoDOM) {
      // console.error("handleTimeUpdate > video.videoDOM ERROR!!");
      return;
    }

    const currentTime = video.videoDOM.currentTime; // 현재 재생 중인 파일 미디어의 재생 시간
    if (currentTime <= 0) return;

    // console.log("response.files: ", response.files);
    // // console.log("file.fileIdx: ", file.fileIdx);
    // const playingTime = getPlayingTimeByFiles(
    //     currentTime,
    //     response.files,
    //     file.fileIdx,
    // ); // 전체 파일의 현재 시간으로 계산

    // const isPrepareNextFile =
    //     file.duration - currentTime < NEXT_FILE_PREPARE_SECONDS
    //         ? true
    //         : false;
    // // const nextFileItem = getNextFileItem(file.fileIdx, response.files);

    // if (isPrepareNextFile && !video.nextPreload) {
    //     dispatch(preloadAction(true));
    // }
    dispatch(timeUpdateAction(currentTime));
  };

  // 미디어 seeked 이벤트
  const handleSeeked = () => {
    dispatch(seekedAction());
  };
  // 미디어 canplay 이벤트
  const handleCanplay = () => {
    if (!video.videoDOM) {
      return;
    }

    /**
     * 아래는 스포일러 방지 VOD 편집 불가 띄우기 위한 임시방편 로직임.
     * 3년이 지나 어떤 영상은 아래 로직 때문에 편집이 안되고 하는데 afstar1에서 다른 영상은 편집이 되어서 왜지?? 해서 확인 후 또 까먹을까봐 정책 남김.
     * 정책 : "스포방지를 위해 어드민에서 임의로 시간조작한 영상들만 편집이 불가능하다."
     * 스포 방지 VOD는 어드민에서 시간을 실제 미디어 시간과 다르게 지정해버림 (ex. https://vod.sooplive.com/player/192770199)
     * 근데 위 영상들을 편집할 때 실제 시간과 달라 에러가 남.
     * 그래서 디비에 저장된 영상 Total 타임과 실제 미디어 타임을 비교해서 1분 이상 차이나면 스포 방지 VOD로 판단해서 편집 불가 띄움.
     */
    const bjId = response.info.user_id || '';
    const adminId = [
      'aflol',
      'afchall',
      'all',
      'lolbjmatch',
      'afstar1',
      'starbjmatch',
      'afgsl',
    ];
    if (!adminId.includes(bjId)) {
      // 계정 미포함하면 리턴
      return;
    }
    if (file.playingIdx !== 0) {
      // 첫 파일 아니면 리턴
      return;
    }
    let duration = video.videoDOM.duration || 0;
    if (duration <= 0) {
      return;
    }
    duration = Math.floor(duration);
    const dbDuration = response.info.total_duration || 0;
    if (duration > dbDuration) {
      return;
    }
    if (dbDuration - duration < 60) {
      return;
    }
    alert(t('편집기 이용이 불가한 VOD입니다.'));
    window.location.href = VOD_AFREECATV_DOMAIN;
  };
  // 미디어 ended 이벤트
  const handleEnded = () => {
    dispatch(endedAction());
  };
  /**
   * hls.js ManifestParsed Event
   * @param event
   * @param data
   */
  const onManifestParsed = () => {
    if (response.info) {
      const videoTag = document.getElementById('video') as HTMLVideoElement;
      if (!videoTag) return;

      dispatch(manifestParsedAction(videoTag, response.info.total_duration));

      // 간헐적으로 seeking 후 seeked이벤트가 안들어오는 케이스가 있어서
      // 영상은 재생되고 있는데 플레이어 재생 시간이 동기화가 안되었음. MANAFEST_PARSED 들어오면 seeked 강제로 줌
      dispatch(seekedAction());

      if (!video.paused) {
        // manifestParsed 오면 미디어 정지 상태임
        // 리덕스의 미디어 재생 상태인데 파일 바껴서 manifestParsed왔을 경우 재생시켜줌
        let mediaCheckTimer = 0;
        mediaCheckTimer = window.setInterval(() => {
          if (videoTag.readyState > 3) {
            videoTag.play();
            window.clearInterval(mediaCheckTimer);
          } else {
            console.log('videoTag.readyState: ', videoTag.readyState);
          }
        }, 100);
      }
    }
  };
  const handleHlsEvent = {
    onManifestParsed,
  };

  // media Ended
  useEffect(() => {
    if (!response.files) {
      // console.error("handleEnded > response.files ERROR!!");
      return;
    }
    if (!video.videoDOM) {
      return;
    }
    if (!video.ended) return;

    let nextFileItem = null;
    nextFileItem = getNextFileItem(file.playingIdx, file.list);

    if (nextFileItem.fileIdx === -1) {
      // 다음 파일 없을 경우 처음으로
      console.log('111111111: ');
      dispatch(seekingAction(0));
    } else {
      let hls = window.hls;
      const nextHls = window.nextHls;
      const videoTag = getElementVideoTag();

      if (!videoTag) return;
      if (!videoTag.parentNode) return;
      // if (!video.nextVideoDOM) return;
      if (!nextHls) return;
      if (!nextHls.media) {
        // console.error("handleEnded > window.nextHls.media ERROR!!");
        return;
      }

      nextHls.media.muted = video.videoDOM.muted;
      nextHls.media.playbackRate = video.videoDOM.playbackRate;
      hls.destroy();
      hls = nextHls;
      videoTag.parentNode.replaceChild(nextHls.media, video.videoDOM);

      dispatch(changeVideoDomAction(nextHls.media as HTMLVideoElement));
      // if (cut.status) {
      // dispatch(changePlayingIdxCutAction(nextFileItem.fileIdx)); // 다음 재생할 파일이 있을 경우
      // } else {
      dispatch(changePlayingIdxAction(nextFileItem.fileIdx)); // 다음 재생할 파일이 있을 경우
      // }
      // nextHls = null;
    }
  }, [video.ended]);

  /**
   * Media timeupdate 처리 함수
   */
  useEffect(() => {
    if (file.list[file.playingIdx].duration === 0) return;
    if (!video.videoDOM) return;
    if (video.seeking) return;

    const playingTime = getPlayingTimeByFiles(
      video.currentMediaTime,
      file.list,
      file.playingIdx,
    ); // 전체 파일의 현재 시간으로 계산

    const duration = file.list[file.playingIdx].duration;
    // const { startTime, endTime, duration: cutDuration } = cut.lists[
    //     cut.cutPlayingIdx
    // ];
    // const bFirstList = cutDuration === 0 ? true : false; // 첫 컷 편집 상태 체크
    // if (cut.status && !bFirstList) {
    // duration = video.videoDOM.duration;
    // playingTime = getPlayingTimeByFiles(
    //     video.currentMediaTime,
    //     cut.lists,
    //     cut.cutPlayingIdx,
    // );
    // const cutList = getCutListInfo(cut.lists, playingTime);
    // if (cutList.duration === 0 && video.paused) {
    //     return;
    // }
    // if (playingTime < startTime) {
    //     dispatch(seekingAction(startTime));
    //     playingTime = startTime;
    // } else if (playingTime > endTime) {
    //     // 구간 넘은 경우이니, 다음 구간으로 시킹
    //     const nextFileItem = getNextCutFileItem(
    //         cut.cutPlayingIdx,
    //         cut.lists,
    //     );
    //     if (nextFileItem.idx === -1) {
    //         console.log("qwioeioqeioqwioeqioqweioqwoieoqweo");
    //         // 다음 재생 구간 없을 경우 정지 및 playhead 편집 구간 끝으로 이동
    //         video.videoDOM.pause();
    //         dispatch(setPlayingTimeAction(nextFileItem.endTime));
    //         return;
    //     }
    //     playingTime = nextFileItem.startTime;
    //     dispatch(changePlayingIdxCutAction(nextFileItem.idx)); // 다음 재생할 구간이 있을 경우
    //     dispatch(seekingAction(nextFileItem.startTime));
    // }
    // cut리듀서 내의 cutStartTime, cutEndTime은 해당 파일의 media 시간 기준으로 셋팅 되어 있음
    // playingTime = cutStartTime + video.currentMediaTime;
    // 현재 playhead 시간이 편집 끝 시간 넘어갈 경우(=재생 중 분할 편집 시간 변경 했을 경우)
    // if (playingTime > cutInfo.cutEndTime) {
    //     console.log("@@@ 넘어감: ");
    //     const nextCutFile = getNextCutFileItem(
    //         cutInfo.fileIdx,
    //         cut.infos,
    //     );
    //     if (nextCutFile.fileIdx === -1) {
    //         if (!video.videoDOM) return;
    //         video.videoDOM.pause();
    //     }
    //     dispatch(changePlayingIdxCutAction(nextCutFile.fileIdx));
    //     return;
    // }
    // const packetizer = getPacketizer(cutInfo.vodUrl);
    // duration = cutInfo.cutEndTime;
    // if (packetizer === WOWZA) {
    //     // wowza 패킷타이저는 endTime을 남은 구간 길이로 넣어줘야함
    //     duration = cutInfo.cutEndTime - cutInfo.cutStartTime;
    // }
    // } else {
    // playingTime = getPlayingTimeByFiles(
    //     video.currentMediaTime,
    //     response.files,
    //     file.playingIdx,
    // ); // 전체 파일의 현재 시간으로 계산
    // duration = file.list[file.playingIdx].duration;
    // const nextFileItem = getNextFileItem(file.fileIdx, response.files);
    // }

    // 컷 편집 때는 파일 분할 구간 계산 시, 에러 있어서 미리 로드 안하게 함
    // @TODO 컷 편집때도 파일 미리 로드되게 해야할듯
    // if (!cut.status) {
    const isPrepareNextFile =
      duration - video.currentMediaTime < NEXT_FILE_PREPARE_SECONDS
        ? true
        : false;

    const {fileIdx} = getNextFileItem(file.playingIdx, file.list); // 다음 파일 재생할게 없으면(영상의 마지막 파일이면) -1로 리턴하고 preloadAction안함
    if (isPrepareNextFile && !video.nextPreload && fileIdx !== -1) {
      dispatch(preloadAction(true));
    }
    // }

    if (!sectionLists[sectionIdx]) return;

    if (sectionLists.length - 1 === sectionIdx) {
      // 마지막 섹션일 때
      if (cut.lists[sectionIdx]) {
        const cutListLastidx = cut.lists[sectionIdx].length - 1;
        if (
          cut.lists[sectionIdx][cutListLastidx].duration !== 0 &&
          cut.lists[sectionIdx][cutListLastidx].endTime < playingTime
        ) {
          dispatch(
            seekingAction(cut.lists[sectionIdx][cutListLastidx].endTime),
          );
          // 이미 paused면 리턴
          if (!video.videoDOM) return;
          if (getPausedState(video.videoDOM)) return;
          video.videoDOM.pause();
          dispatch(pauseAction());
          return;
          // 마지막 섹션의 마지막 컷 편집 영역 끝을 playingTime이 넘어서면 미디어 일시정지 시킴
          // if (!video.videoDOM) return;

          // // 이미 paused면 리턴
          // if (getPausedState(video.videoDOM)) return;
          // video.videoDOM.pause();
          // dispatch(pauseAction());
          // return;
        }
      }
    }

    dispatch(setPlayingTimeAction(playingTime));
  }, [video.currentMediaTime]);

  useEffect(() => {
    // 컷 편집 모드 상태 아니면 리턴
    if (!cut.status) return;
    if (!video.videoDOM) return;
    if (cut.cutPlayingIdx === -1) {
      // 다음 재생 구간 없을 경우 정지 및 playhead 편집 구간 끝으로 이동
      video.videoDOM.pause();
      const len = cut.lists[sectionIdx].length;
      dispatch(setPlayingTimeAction(cut.lists[sectionIdx][len - 1].endTime));
    }
  }, [cut.cutPlayingIdx]);

  // 다음 파일 미리 로드
  useEffect(() => {
    const preloadNextFile = async () => {
      if (!response.files) {
        console.error('useEffect > video.currentMediaTime ERROR!!');
        return;
      }
      if (!video.nextPreload) {
        // window.nextHls = null;
        return;
      }

      let nextFileItem = null;
      nextFileItem = getNextFileItem(file.playingIdx, file.list);

      if (nextFileItem.fileIdx !== -1) {
        // 구독전용인 경우 영상 로드 전에 구독 세션 초기화 및 체크 실행
        if (isSubscriptionVod) {
          const hasValidSession =
            await subscriptionSession.startSessionTracking();

          if (!hasValidSession) return;
        }

        const nextVideoTag = setElementVideoTag();
        console.log('!!!!! nextPreload');
        HlsContainer({
          hlsUrl: nextFileItem.url,
          videoRef: nextVideoTag,
          startPosition: -1,
          handleHlsEvent,
          isPrepareNextFile: video.nextPreload,
          isSubscriptionVod,
        });
        // dispatch(preloadAction(true));
      }
    };

    preloadNextFile();
  }, [video.nextPreload]);

  // Video tag events
  // nextPreload 발생시에만 DOM이 바껴서 이벤트 재등록
  useEffect(() => {
    if (!video.videoDOM) return;

    console.log('VIDEO TAG MOUNT');
    video.videoDOM.addEventListener('timeupdate', handleTimeUpdate);
    video.videoDOM.addEventListener('seeked', handleSeeked);
    video.videoDOM.addEventListener('playing', handlePlaying);
    video.videoDOM.addEventListener('pause', handlePause);
    video.videoDOM.addEventListener('canplay', handleCanplay);
    video.videoDOM.addEventListener('ended', handleEnded);

    // 다음 파일 preload 했었으면 false로 초기화 하고 video play함(5초전에 미리 로드했으므로 부드럽게 재생효과냄)
    if (video.nextPreload) {
      let mediaCheckTimer = 0;
      mediaCheckTimer = window.setInterval(() => {
        if (!video.videoDOM) return;

        if (video.videoDOM.readyState > 3) {
          dispatch(preloadAction(false));
          video.videoDOM.play();
          window.clearInterval(mediaCheckTimer);
        } else {
          console.log(
            '@@@@@@@@@@@@@@@@@@@@@@@@@ video.videoDOM.readyState: ',
            video.videoDOM.readyState,
          );
        }
      }, 100);
    }

    return () => {
      if (!video.videoDOM) return;

      console.log('VIDEO TAG UNMOUNT');
      video.videoDOM.removeEventListener('timeupdate', handleTimeUpdate);
      video.videoDOM.removeEventListener('seeked', handleSeeked);
      video.videoDOM.removeEventListener('playing', handlePlaying);
      video.videoDOM.removeEventListener('pause', handlePause);
      video.videoDOM.removeEventListener('canplay', handleCanplay);
      video.videoDOM.removeEventListener('ended', handleEnded);
    };
  }, [video.videoDOM]);

  // hls.js
  useEffect(() => {
    const initHls = async () => {
      if (!file.list[file.playingIdx].vod_url) return;
      // nexPreload=true 면 다음 파일 로드 했으므로 아래 로직 안태움
      if (video.nextPreload) return;
      if (!response.info) return;

      // 구독전용인 경우 영상 로드 전에 구독 세션 초기화 및 체크 실행
      if (isSubscriptionVod) {
        const hasValidSession =
          await subscriptionSession.startSessionTracking();

        if (!hasValidSession) return;
      }

      const videoTag = getElementVideoTag();
      if (!videoTag) {
        // 최초 로드 시 video 태그 없으니 생성
        const createVideoTag = setElementVideoTag();
        const videoLayer = document.getElementById('videoLayer');
        if (videoLayer) {
          videoLayer.appendChild(createVideoTag);
          HlsContainer({
            hlsUrl: vodUrl,
            videoRef: createVideoTag,
            startPosition: -1,
            handleHlsEvent,
            isSubscriptionVod,
          });
        }
      } else {
        // 파일 변경 시, 기존 video tag로 hls 객체 새로 생성

        // if (cut.status) {
        //     if (
        //         video.playingTime >=
        //             cut.infos[cut.cutPlayingIdx].cutStartTime &&
        //         video.playingTime <= cut.infos[cut.cutPlayingIdx].cutEndTime
        //     ) {
        //         // 모든 파일 기준 현재 재생 중인 시간이 편집한 시간 내에 포함될 경우에는 hls 객체 새로 생성 안함
        //         return;
        //     }
        //     vodUrl = cut.infos[cut.cutPlayingIdx].vodUrl;
        // }

        const totalDuration = getTotalDurationByIndex(
          file.list,
          file.playingIdx,
        );
        let seekTargetTime = video.playingTime - totalDuration;
        if (seekTargetTime < 0) {
          seekTargetTime = -1;
        }

        HlsContainer({
          hlsUrl: vodUrl,
          videoRef: videoTag,
          startPosition: seekTargetTime,
          handleHlsEvent,
          isSubscriptionVod,
        });
      }
    };

    initHls();
  }, [file.list[file.playingIdx].vod_url]);

  // seeking 했을 경우
  useEffect(() => {
    if (!video.seeking) {
      // console.error("VideoContainer > useEffect video.seeking ERROR!!");
      return;
    }
    if (!video.videoDOM) {
      console.error('VideoContainer > useEffect video.videoDOM ERROR!!');
      return;
    }
    if (!response.files) {
      console.error('VideoContainer > useEffect response.files ERROR!!');
      return;
    }

    const {videoDOM} = video;

    const playingTime = video.playingTime;
    const seekingIdx = getFileIndexByTime(file.list, playingTime); // seeking한 현재 파일 인덱스
    const totalDuration = getTotalDurationByIndex(file.list, seekingIdx); // 현재 파일 인덱스 이전 까지 미디어 총 시간
    let seekTime = playingTime - totalDuration; // 실제 seeking 시간(현재 파일 인덱스의 미디어 재생 시간)

    if (isTimeInCurrentItem(seekingIdx, file.playingIdx)) {
      // 현재 아이템 내의 파일일 경우
      if (!isNaN(videoDOM.duration)) {
        const mediaDuration = Math.floor(videoDOM.duration); // 소수점 버림한 실제 video duration
        // 소수점 버린 seeking 시간이 실제 duration보다 크거나 같을 경우엔 media duration값으로 seeking함.
        // float형이나 넘게 했을 경우 media가 강제로 replay해버리는 이슈가 있음
        if (Math.floor(seekTime) >= mediaDuration) {
          seekTime = mediaDuration;
        }
      }

      const isPaused = videoDOM.paused;

      if (!isPaused) videoDOM.pause();
      videoDOM.currentTime = seekTime;

      let mediaCheckTimer = 0;
      mediaCheckTimer = window.setInterval(() => {
        if (videoDOM.readyState > 3) {
          if (!isPaused) videoDOM.play();
          window.clearInterval(mediaCheckTimer);
        } else {
          console.log('videoDOM.readyState: ', videoDOM.readyState);
        }
      }, 100);
    } else {
      // 파일 바뀔 경우
      const changeFileItem = getChangeFileItem(videoDOM, file.list, seekingIdx);
      // 재생 파일 변경
      dispatch(changePlayingIdxAction(changeFileItem.fileIdx));

      let {nextHls} = window;
      if (video.nextPreload && nextHls) {
        nextHls.destroy();
        nextHls = undefined;
        dispatch(preloadAction(false));
      }
    }
    dispatch(changeSeekChatAction(true)); // 채팅 seek 이벤트 dispatch
    dispatch(seekedAction());
  }, [video.seeking]);

  return (
    <>
      <Video
        // videoRef={videoRef}
        onClick={(e: any) => setPaused(e)}
        // onCanPlay={handleCanPlay}
        // onPlaying={handlePlaying}
        // onPause={handlePause}
        // onTimeUpdate={handleTimeUpdate}
        // onSeeked={handleSeeked}
        // onEnded={handleEnded}
      />
      <ScreenContainer />
    </>
  );
};

export default VideoContainer;
